import "@hotwired/turbo-rails";
import "jquery";
import { Modal, Dropdown, Tooltip, Alert, Carousel, Popover } from "bootstrap"

window.bootstrap = { Modal, Dropdown, Tooltip, Alert, Carousel, Popover }
import "./controllers/search.js"


import { Application } from "@hotwired/stimulus"

const application = new Application()
window.Stimulus = application

window.switchCarouselSlide = function(index) {
    const carousel = document.getElementById('itemCarousel')
    if (carousel) {
        const instance = Carousel.getInstance(carousel) || new Carousel(carousel)
        instance.to(index)
    }
}

const initCarousel = () => {
    const carousel = document.getElementById('itemCarousel')
    if (carousel) {
        new Carousel(carousel)
    }
}

document.addEventListener('DOMContentLoaded', initCarousel)
document.addEventListener('turbo:load', initCarousel)
